import FormAccessGroups from "../FormAccessGroups/FormAccessGroups";
import { useLocation, useParams } from "react-router-dom";
import "./CadastroAccessGroups.css";
import { useEffect, useState } from "react";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import AccessGroupService from "../../../services/AccessGroupService";

const CadastroAccessGroups = () => {
	const { accessGroupId } = useParams();
	const { state } = useLocation();
	const [accessGroup, setAccessGroup] = useState(state);
	const [type, setType] = useState("");

	async function loadAccessGroup(id) {
		const response = await AccessGroupService.getOneUuid(id);
		if (response.data) {
			setAccessGroup(response.data);
		}
	}

	useEffect(() => {
		setType(accessGroupId || state ? "edicao" : "cadastro");

		if (accessGroup) {
			setAccessGroup(state);
			return;
		}

		if (accessGroupId) {
			loadAccessGroup(accessGroupId);
		}
	}, [state, accessGroupId]);

	return (
		<CadastroContainer>
			<FormAccessGroups accessGroup={accessGroup} type={type} />
		</CadastroContainer>
	);
};

export default CadastroAccessGroups;
